import dayjs from "dayjs";

import { DateRangeType } from "../../../lib/graphql";
import { useDateRangeTypeOptions } from "../../../lib/hooks";
import {
  DatePicker,
  isRangeType,
  type RangePickerProps,
  SelectField,
} from "../../form";

export interface DateFilterValue {
  rangeType?: DateRangeType;
  range?: RangePickerProps["value"];
}

interface DateFilterInputProps {
  id?: string;
  value?: DateFilterValue;
  asStringDate?: boolean;
  onChange?(value?: DateFilterValue): void;
}

export function DateFilterInput({
  id,
  value,
  asStringDate = false,
  onChange,
}: DateFilterInputProps) {
  const rangeType = value?.rangeType;
  const changeRange = (range: DateFilterValue["range"]) =>
    onChange?.({ rangeType, ...(range ? { range } : {}) });

  return (
    <>
      <SelectField
        id={id}
        value={rangeType}
        optionsHook={useDateRangeTypeOptions}
        showSearch={false}
        onChange={(nextRangeType) => {
          if (!nextRangeType) {
            onChange?.(undefined);
            return;
          }

          onChange?.({
            rangeType: nextRangeType,
            ...(isRangeType(nextRangeType) && value?.range
              ? { range: value.range }
              : {}),
          });
        }}
      />

      {isRangeType(rangeType) && (
        <DatePicker.RangePicker
          picker={rangeType === DateRangeType.MonthRange ? "month" : "date"}
          value={value?.range}
          style={{ marginTop: "5px", width: "100%" }}
          {...(asStringDate
            ? {
                asStringDate: true as const,
                onChange: (range: [string | null, string | null] | null) =>
                  // The filter API expects tenant-local timestamps, not date-only strings.
                  changeRange(
                    range && [
                      range[0] ? dayjs.tz(range[0]) : null,
                      range[1] ? dayjs.tz(range[1]) : null,
                    ]
                  ),
              }
            : { onChange: changeRange })}
        />
      )}
    </>
  );
}
